<template>
  <div>
    <!-- 订单明细查询 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>活动管理</el-breadcrumb-item>
      <el-breadcrumb-item>活动列表</el-breadcrumb-item>
      <el-breadcrumb-item>活动详情</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- <el-card> -->

    <!-- 充值统计 -->
    <div>
      <el-card style="margin-top:20px">
        <div class="titleStyle">
          <el-date-picker
            v-model="value1"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
          <el-input placeholder="请输入订单号"></el-input>
          <el-select v-model="value" clearable placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-button>查询</el-button>
        </div>
      </el-card>
      <el-card style="margin-top:20px">
        <div class="balance">
          <span>当前剩余余额:</span>
          <span>123</span>
          <span>元</span>
        </div>
        <div class="conentRow">
          <div>
            <span
              v-for="(v,i) in tabBtn"
              :key="v.id"
              @click="tabFn(i)"
              :class="activeIndex==i?'active':''"
            >{{v.name}}</span>
          </div>
          <el-button class="conentBtn" type="primary">结算</el-button>
        </div>
        <!-- 未结算 -->
        <div v-if="activeIndex==0">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%"
            :header-cell-style="tableHeaderColor"
            :cell-style="cellStyle"
            @selection-change="handleSelectionChange"
          >
            <!-- <el-table-column type="selection" width="55"></el-table-column> -->
            <el-table-column label="选择">
              <template slot-scope="scope">{{ scope.row.date }}</template>
            </el-table-column>
            <el-table-column prop="name" label="排序" width="120"></el-table-column>
            <el-table-column prop="address" label="业务时间"></el-table-column>
            <el-table-column prop="address" label="业务时间分销商"></el-table-column>
            <el-table-column prop="address" label="订单号"></el-table-column>
            <el-table-column prop="address" label="应结算(元)"></el-table-column>
            <el-table-column prop="address" label="未结算(元)"></el-table-column>
          </el-table>
          <!-- 分页开始 -->
          <div class="pagination">
            <span class="demonstration">共几条记录，</span>
            <span class="demonstration">当前显示第几页</span>
            <el-pagination background layout="prev, pager, next" :total="1000"></el-pagination>
          </div>
          <!-- 分页结束 -->
        </div>
        <!-- 已结算 -->
        <div v-if="activeIndex==1">
          <el-table
            :data="tableData"
            :header-cell-style="tableHeaderColor"
            :cell-style="cellStyle"
            style="width: 100%"
          >
            <el-table-column prop="date" label="分销商"></el-table-column>
            <el-table-column prop="name" label="业务时间"></el-table-column>
            <el-table-column prop="address" label="订单号"></el-table-column>
            <el-table-column prop="address" label="应结算(元)"></el-table-column>
            <el-table-column prop="address" label="未结算(元)"></el-table-column>
          </el-table>
          <!-- 分页开始 -->
          <div class="pagination">
            <span class="demonstration">共几条记录，</span>
            <span class="demonstration">当前显示第几页</span>
            <el-pagination background layout="prev, pager, next" :total="1000"></el-pagination>
          </div>
          <!-- 分页结束 -->
        </div>
        <!-- 已提交 -->
        <div v-if="activeIndex==2">
          <el-table
            :data="tableData"
            :header-cell-style="tableHeaderColor"
            :cell-style="cellStyle"
            style="width: 100%"
          >
            <el-table-column prop="date" label="账单号"></el-table-column>
            <el-table-column prop="name" label="业务周期"></el-table-column>
            <el-table-column prop="address" label="订单号"></el-table-column>
            <el-table-column prop="address" label="应结算金额(元)"></el-table-column>
            <el-table-column prop="address" label="未结算金额(元)"></el-table-column>
            <el-table-column prop="address" label="未开发票金额(元)"></el-table-column>
            <el-table-column prop="address" label="状态">
              <template slot-scope="scope">
                <img src="@/images/scenic/wkp.png" alt />
                <!-- <img src="@/images/scenic/wqr.png" alt /> -->
                <span style="margin-left:10px">{{scope.row.address}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="address" label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="seeInfoFn(scope.row)">查看详情</el-button>
                <el-button type="text" @click="invoiceFn(scope.row)">开发票</el-button>
                <el-button type="text" style="color: #E74C3C;">删除</el-button>
                <el-button type="text">下载</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页开始 -->
          <div class="pagination">
            <span class="demonstration">共几条记录，</span>
            <span class="demonstration">当前显示第几页</span>
            <el-pagination background layout="prev, pager, next" :total="1000"></el-pagination>
          </div>
          <!-- 分页结束 -->
        </div>
      </el-card>
    </div>
    <!-- </el-card> -->
    <!-- 充值统计结束 -->

    <!-- 开发票开始 -->
    <orderQueryDialog v-if="invoicevisible" ref="invoiceDialog"></orderQueryDialog>
    <!-- 开发票结束 -->
    <!-- 查看详情开始 -->
    <orderQueryDialog v-if="seeinfovisible" ref="seeinfoDialog"></orderQueryDialog>
    <!-- 查看详情结束 -->
  </div>
</template>

<script>
import orderQueryDialog from "./dialog/orderQueryDialog.vue";
export default {
  components: {
    orderQueryDialog
  },
  data() {
    return {
      invoicevisible: false, // 开发票
      seeinfovisible: false, // 查看详情
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "57674"
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "2464634"
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "43434"
        },
        {
          date: "2016-05-03",
          name: "王小虎",
          address: "1345"
        }
      ],
      multipleSelection: [],
      tabBtn: [
        {
          id: 1,
          name: "未结算"
        },
        {
          id: 2,
          name: "已结算"
        },
        {
          id: 3,
          name: "已提交"
        }
      ],
      form: {
        name: ""
      },
      radio: "",
      activeIndex: "", // 选中tab
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      value1: "",
      options: [
        {
          value: "选项1",
          label: "黄金糕"
        },
        {
          value: "选项2",
          label: "双皮奶"
        },
        {
          value: "选项3",
          label: "蚵仔煎"
        },
        {
          value: "选项4",
          label: "龙须面"
        },
        {
          value: "选项5",
          label: "北京烤鸭"
        }
      ],
      value: ""
    };
  },
  methods: {
    // 查看详情
    seeInfoFn(row) {
      this.seeinfovisible = true;
      this.$nextTick(() => {
        this.$refs.seeinfoDialog.seeInfo(row);
      });
    },
    // 已提交开发票
    invoiceFn(row) {
      this.invoicevisible = true;
      this.$nextTick(() => {
        this.$refs.invoiceDialog.invoice(row);
      });
    },
    // 表格全选
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    tabFn(index) {
      // console.log(index);
      this.activeIndex = index;
      console.log(this.activeIndex);
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang='less' scoped>
.titleStyle {
  .el-input {
    width: 240px;
    margin: 0 20px;
  }
  .el-select {
    width: 260px;
    margin-right: 20px;
  }
  .el-button {
    width: 100px;
    border: none;
    background: #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
  }
}
.btnS {
  width: 100%;
  display: flex;
  justify-content: center;
  background: unset;
  margin-left: -180px;
  // margin-top: 31px;
  .el-button {
    width: 100px;
    background: #d9d9d9;
    border-radius: 4px;
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
    border: none;
  }
  .btnL {
    width: 100px;
    background: #246deb;
    border-radius: 4px;
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
  }
}

.ziZhuCZ {
  width: 100%;
  display: flex;
  justify-content: space-between;
  /deep/.el-form-item__label {
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: right;
    color: #666666;
  }
  .btn {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-left: -80px;
    margin-top: 31px;
    .el-button {
      width: 100px;
      background: #d9d9d9;
      border-radius: 4px;
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      border: none;
    }
    .btnL {
      width: 100px;
      background: #246deb;
      border-radius: 4px;
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
    }
  }
  .zCLeft {
    width: 49%;
    padding: 20px;
    box-sizing: border-box;
    height: 740px;
    background: #ffffff;
    border-radius: 4px;
    .el-form-item {
      margin-bottom: 20px;
    }
    .Botm {
      margin-bottom: 0px;
    }
    .itemFour {
      display: flex;
      height: 175px;
      .el-input {
        width: 300px;
      }
      .zhu {
        height: 30px;
        line-height: 25px;
      }
      > div:nth-child(2) {
        font-family: "OPPOSans";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #e74c3c;
      }
    }
    .mayMode {
      > div:nth-child(1) {
        font-family: "OPPOSans";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
      }
      > div:nth-child(2) {
        height: 30px;
        line-height: 30px;
        width: 100%;
        height: 190px;
        padding: 20px;
        box-sizing: border-box;
        background: #ffffff;
        border: 1px solid #e5e5ea;
        border-radius: 4px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        > div:nth-child(1) {
          width: 50%;
          /deep/.el-descriptions
            :not(.is-bordered)
            .el-descriptions-item__cell {
            padding-bottom: 4px;
          }
          /deep/.el-descriptions-item__label:not(.is-bordered-label) {
            margin-right: 10px;
            font-family: "OPPOSans";
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            color: #666666;
          }
          /deep/.el-descriptions-item__content {
            word-break: break-word;
            overflow-wrap: break-word;
            font-family: "OPPOSans";
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            color: #000000;
          }
        }
        > div:nth-child(2) {
          width: 30%;
          font-family: "OPPOSans";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          color: #e74c3c;
          > span:nth-child(1) {
            margin-right: 10px;
          }
        }
      }
    }
    .itemTwo {
      display: flex;
      .el-input {
        width: 267px;
      }
      span {
        font-family: "OPPOSans";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        margin-left: 10px;
      }
    }
    .itemOne {
      display: flex;
      .el-input {
        width: 145px;
      }
      span {
        font-family: "OPPOSans";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        margin-left: 10px;
      }
    }
    > div:nth-child(1) {
      width: 100%;
      height: 40px;
      line-height: 30px;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      color: #000000;
    }
    // 分割线
    /deep/.el-divider--horizontal {
      display: block;
      height: 1px;
      width: 100%;
      // margin: 20px 0;
    }
  }
  .zCRight {
    width: 49%;
    height: 740px;
    padding: 20px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 4px;
    > div:nth-child(1) {
      width: 100%;
      height: 40px;
      line-height: 30px;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      color: #000000;
    }
    // 分割线
    /deep/.el-divider--horizontal {
      display: block;
      height: 1px;
      width: 100%;
      // margin: 20px 0;
    }
  }
}
.navFrame {
  width: 100%;
  display: flex;
  margin: 17px 0;
  .navDataBig {
    width: 100%;
    height: 150px;
    display: flex;
    > div {
      width: 25%;
      height: 150px;
      background: #ffffff;
      border-radius: 4px;
      margin-right: 20px;
      > div:nth-child(1) {
        width: 84px;
        height: 20px;
        margin-left: 20px;
        margin-top: 17px;
        font-family: ".PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        /* identical to box height */

        color: #666666;
      }
      > div:nth-child(2) {
        height: 56px;
        display: flex;
        margin-top: 40px;
        // background: red;
        img {
          width: 80px;
          height: 60px;
          margin-right: 20px;
        }
        span {
          width: 100%;
          height: 100px;
          margin-bottom: 20px;
          display: flex;
          > span:nth-child(1) {
            display: block;
            width: 120px;
            height: 100%;
            line-height: 100px;
            margin-left: 21px;
            margin-right: 8px;
            font-family: ".PingFang SC";
            font-style: normal;
            font-weight: 600;
            font-size: 40px;
            line-height: 56px;
            /* identical to box height */
            color: #246deb;
          }
          > span:nth-child(2) {
            display: block;
            width: 20px;
            height: 100%;
            margin-top: 20px;
            font-family: ".PingFang SC";
            font-style: normal;
            font-weight: 400;
            font-size: 20px;
            line-height: 28px;
            /* identical to box height */
            color: #797979;
          }
        }
      }
    }
  }
}
.balance {
  height: 18px;
  font-family: "OPPOSans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #666666;
  margin-bottom: 20px;
  > span:nth-child(2) {
    color: #4d88ef;
    margin: 0 10px;
  }
}
.titleSear {
  margin-bottom: 20px;
  .el-input {
    width: 300px;
  }
  .el-button {
    width: 100px;
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    border: none;
    margin-left: 20px;
  }
}
.conentRow {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  > div:nth-child(1) {
    width: 50%;
    display: flex;
    .active {
      background: #246deb;
    }
    span {
      width: 120px;
      height: 40px;
      display: block;
      background: #d9d9d9;
      border-radius: 4px;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 40px;
      text-align: center;
      color: #ffffff;
      margin-right: 20px;
    }
  }
  .conentBtn {
    width: 100px;
    background: #ffffff;
    border: 1px solid #246deb;
    border-radius: 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #246deb;
  }
}

.qxsq {
  // 分页
  .pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 32px;
    margin: 30px auto 20px;
    span {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
    }
  }
}

.tab {
  display: flex;
  margin: 20px 0;
  .activeTab {
    background: #246deb;
  }
  span {
    width: 120px;
    height: 40px;
    display: block;
    border-radius: 0px 0px 4px 4px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 40px;
    color: #ffffff;
    border: none;
    text-align: center;
    background: #d9d9d9;
    margin-right: 20px;
  }
}
// /deep/.el-dialog__header {
//   height: 60px;
//   line-height: 60px;
//   padding: 0;
// }

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 20px 0;
}
// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 45px auto 40px;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}
</style>